import { render, staticRenderFns } from "./Pairing.vue?vue&type=template&id=34adb8c9&scoped=true&"
import script from "./Pairing.vue?vue&type=script&lang=js&"
export * from "./Pairing.vue?vue&type=script&lang=js&"
import style0 from "./Pairing.vue?vue&type=style&index=0&id=34adb8c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34adb8c9",
  null
  
)

export default component.exports